import { Injectable } from '@angular/core';
import { ESeaSegment } from '../../enums/seaSegment.enum';
import { EAirSegment } from '../../enums/airSegment.enum';
import { ERailSegment } from '../../enums/railSegment.enum';
import { ERoadSegment } from '../../enums/roadSegment.enum';
import { TransportSegmentsModel } from '../../models/transportSegment/transportSegments.model';

@Injectable()
export class SegmentsService {
  public getSegmentsList(): TransportSegmentsModel {
    return {
      sea: this.getSeaSegmentsList(),
      road: this.getRoadSegmentsList(),
      air: this.getAirSegmentsList(),
      rail: this.getRailSegmentsList(),
    };
  }

  /**
   * Retrieves a list of sea transport segments.
   * @returns {string[]} An array of sea transport segment names, formatted as uppercase strings with spaces replacing underscores.
   */
  private getSeaSegmentsList(): string[] {
    return Object.keys(ESeaSegment).map((key) =>
      key.replace(/_/g, ' ').toUpperCase()
    );
  }

  /**
   * Retrieves a list of road transport segments.
   * @returns {string[]} An array of road transport segment names, formatted as uppercase strings with spaces replacing underscores.
   */
  private getRoadSegmentsList(): string[] {
    return Object.keys(ERoadSegment).map((key) =>
      key.replace(/_/g, ' ').toUpperCase()
    );
  }

  /**
   * Retrieves a list of air transport segments.
   * @returns {string[]} An array of air transport segment names, formatted as uppercase strings with spaces replacing underscores.
   */
  private getAirSegmentsList(): string[] {
    return Object.keys(EAirSegment).map((key) =>
      key.replace(/_/g, ' ').toUpperCase()
    );
  }

  /**
   * Retrieves a list of rail transport segments.
   * @returns {string[]} An array of rail transport segment names, formatted as uppercase strings with spaces replacing underscores.
   */
  private getRailSegmentsList(): string[] {
    return Object.keys(ERailSegment).map((key) =>
      key.replace(/_/g, ' ').toUpperCase()
    );
  }
}
